module.exports = __webpack_public_path__ + "static/media/Card_PA.39d6f9d8.svg";